import cn from "classnames"
import { ReactNode } from "react"

import styles from "./styles.module.scss"

interface Props {
    children: ReactNode
    className?: string
    isJustifyContent?: "center" | "start"
}

export function HeaderRoot({ children, className, isJustifyContent = "center" }: Props) {
    return (
        <div
            className={cn(
                styles.container,
                "py-2 py-md-3",
                {
                    [styles.isJustifyContentCenter]: isJustifyContent === "center",
                    [styles.isJustifyContentStart]: isJustifyContent === "start",
                },
                className
            )}
        >
            {children}
        </div>
    )
}
